var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { toFloatPriceValue } from '@logic/helpers/currency';
import qs from 'qs';
var isLoggedIn = function () {
    var _a, _b;
    var hasSession = localStorage.getItem('session');
    if (!hasSession) {
        return { state: 'not logged in' };
    }
    return ((_b = new Date(((_a = JSON.parse(hasSession)) === null || _a === void 0 ? void 0 : _a.expiration) || '')) === null || _b === void 0 ? void 0 : _b.getTime()) > Date.now() ? { state: 'logged in' } : { state: 'not logged in' };
};
export function initializeGTM(history) {
    var windowAsAny = window;
    var getLocation = function () { return ({
        pathname: document.location.pathname,
        search: qs.parse(document.location.search.slice(1)),
    }); };
    var prevLocation = getLocation();
    history.listen(function () {
        var currLocation = getLocation();
        var changed = prevLocation.pathname !== currLocation.pathname || prevLocation.search.q !== currLocation.search.q;
        if (changed) {
            prevLocation = currLocation;
            windowAsAny.dataLayer.push(__assign({ event: 'Location Change' }, isLoggedIn()));
        }
    });
}
export var createCategory = function (main, minor) { return (__spreadArray([main], __read(minor)).map(function (c) { return c.replace(/\//g, '&#8725;'); }).join(' / ')); };
export function pushCheckoutInfo(params) {
    var windowAsAny = window;
    windowAsAny.dataLayer = windowAsAny.dataLayer || [];
    windowAsAny.dataLayer.push(__assign({ ecommerce: {
            currencyCode: params.currencyCode,
            checkout: {
                actionField: {
                    step: params.step,
                    products: [{
                            id: "" + params.eventId,
                            name: params.fullEventName,
                            price: toFloatPriceValue(params.price),
                            quantity: params.quantity,
                            category: createCategory('Tickets', params.category),
                        }],
                },
            },
        }, event: 'checkout' }, isLoggedIn()));
}
export function pushPurchaseInfo(params) {
    return __awaiter(this, void 0, void 0, function () {
        var windowAsAny, PhoneNumberLib, formatPhoneNumber, getUserData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    windowAsAny = window;
                    windowAsAny.dataLayer = windowAsAny.dataLayer || [];
                    return [4 /*yield*/, import('awesome-phonenumber')];
                case 1:
                    PhoneNumberLib = (_a.sent()).default;
                    formatPhoneNumber = function (userData) {
                        if (!userData.phoneNumber || !userData.phoneRegionCode) {
                            return undefined;
                        }
                        var pn = new PhoneNumberLib(userData.phoneNumber, userData.phoneRegionCode);
                        return pn.getNumber('international').replace(' ', '');
                    };
                    getUserData = function (userData) {
                        var _a;
                        if (!userData)
                            return {
                                email: '',
                                phone_number: '',
                                first_name: '',
                                last_name: '',
                                street: '',
                                city: '',
                                country: '',
                                postal_code: ''
                            };
                        return {
                            email: userData.email || '',
                            phone_number: (_a = formatPhoneNumber(userData)) !== null && _a !== void 0 ? _a : '',
                            first_name: userData.fullName ? userData.fullName.split(' ').shift() : '',
                            last_name: userData.fullName ? userData.fullName.split(' ').pop() : '',
                            street: userData.line1 || '',
                            city: userData.city || '',
                            country: userData.country || '',
                            postal_code: userData.postalCode || ''
                        };
                    };
                    windowAsAny.dataLayer.push(__assign({ cid: params.cid, ecommerce: {
                            currencyCode: params.currencyCode,
                            purchase: {
                                actionField: {
                                    id: "" + params.transactionId,
                                    revenue: toFloatPriceValue(params.costs.total),
                                    tax: '0.00',
                                    shipping: '0.00',
                                },
                                products: [{
                                        id: '001',
                                        name: 'Transaction Fee',
                                        price: toFloatPriceValue(params.costs.transactionFeeGross),
                                        quantity: 1,
                                        category: createCategory('Transaction Fee', params.category),
                                    },
                                    {
                                        id: '002',
                                        name: 'Delivery',
                                        price: toFloatPriceValue(params.costs.deliveryCostGross),
                                        quantity: 1,
                                        category: createCategory('Delivery Fee', params.category),
                                    }, {
                                        id: "" + params.eventId,
                                        name: params.fullEventName,
                                        price: toFloatPriceValue(params.costs.ticketsCost / params.quantity),
                                        quantity: params.quantity,
                                        category: createCategory('Tickets', params.category),
                                    }],
                                userData: getUserData(params.userData),
                            },
                        }, event: 'Purchase' }, isLoggedIn()));
                    return [2 /*return*/];
            }
        });
    });
}
export function pushProductDetailView(params) {
    var windowAsAny = window;
    windowAsAny.dataLayer = windowAsAny.dataLayer || [];
    windowAsAny.dataLayer.push(__assign({ ecommerce: {
            detail: {
                actionField: { list: undefined },
                products: [{
                        id: "" + params.eventId,
                        name: "" + params.fullEventName,
                        price: undefined,
                        quantity: undefined,
                        category: createCategory('Tickets', params.category),
                    }],
            },
        }, event: 'ProductDetailView' }, isLoggedIn()));
}
export function pushAddToBasket(params) {
    var windowAsAny = window;
    windowAsAny.dataLayer = windowAsAny.dataLayer || [];
    windowAsAny.dataLayer.push(__assign({ ecommerce: {
            add: {
                products: [{
                        id: "" + params.eventId,
                        name: "" + params.fullEventName,
                        price: toFloatPriceValue(params.price),
                        quantity: params.quantity,
                        category: createCategory('Tickets', params.category),
                    }],
            },
        }, event: 'AddToBasket' }, isLoggedIn()));
}
